import { sizeNative as size } from "./size";
import { MetaTokenProperties } from "./types";

export type FontFamilyPrefix = 'font-family';
type FontFamilyAlias = 'sans' | 'mono';

export type FontSizePrefix = 'font-size';
export type FontSizeScale =
    | '275'
    | '300'
    | '325'
    | '350'
    | '400'
    | '450'
    | '500'
    | '550'
    | '600'
    | '700'
    | '750'
    | '800'
    | '900'
    | '1000';

export type FontLineHeightPrefix = 'font-line-height';
export type FontLineHeightScale =
    | '300'
    | '400'
    | '500'
    | '600'
    | '700'
    | '800'
    | '1000'
    | '1200';

export type FontLetterSpacingPrefix = 'font-letter-spacing';
export type FontLetterSpacingAlias = 'densest' | 'denser' | 'dense' | 'normal';

export type FontWeightPrefix = 'font-weight';
export type FontWeightAlias = 'regular' | 'medium' | 'semibold' | 'bold';

export type FontPrefix =
    | FontFamilyPrefix
    | FontLetterSpacingPrefix
    | FontLineHeightPrefix
    | FontSizePrefix
    | FontWeightPrefix;

export type FontTokenName =
    | `${FontFamilyPrefix}-${FontFamilyAlias}`
    | `${FontLetterSpacingPrefix}-${FontLetterSpacingAlias}`
    | `${FontLineHeightPrefix}-${FontLineHeightScale}`
    | `${FontSizePrefix}-${FontSizeScale}`
    | `${FontWeightPrefix}-${FontWeightAlias}`;

export type FontTokenGroup = {
    [TokenName in FontTokenName]: string;
};

export const font: {
    [TokenName in FontTokenName]: MetaTokenProperties;
} = {
    'font-family-sans': {
        value:
            "'Inter', -apple-system, BlinkMacSystemFont, 'San Francisco', 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif",
    },
    'font-family-mono': {
        value:
            "ui-monospace, SFMono-Regular, 'SF Mono', Consolas, 'Liberation Mono', Menlo, monospace",
    },
    'font-size-275': {
        value: size[275],
        unit: 'px'
    },
    'font-size-300': {
        value: size[300],
        unit: 'px'
    },
    'font-size-325': {
        value: size[325],
        unit: 'px'
    },
    'font-size-350': {
        value: size[350],
        unit: 'px'
    },
    'font-size-400': {
        value: size[400],
        unit: 'px'
    },
    'font-size-450': {
        value: size[450],
        unit: 'px'
    },
    'font-size-500': {
        value: size[500],
        unit: 'px'
    },
    'font-size-550': {
        value: size[550],
        unit: 'px'
    },
    'font-size-600': {
        value: size[600],
        unit: 'px'
    },
    'font-size-700': {
        value: size[700],
        unit: 'px'
    },
    'font-size-750': {
        value: size[750],
        unit: 'px'
    },
    'font-size-800': {
        value: size[800],
        unit: 'px'
    },
    'font-size-900': {
        value: size[900],
        unit: 'px'
    },
    'font-size-1000': {
        value: size[1000],
        unit: 'px'
    },
    'font-weight-regular': {
        value: 450,
    },
    'font-weight-medium': {
        value: 550,
    },
    'font-weight-semibold': {
        value: 650,
    },
    'font-weight-bold': {
        value: 700,
    },
    'font-letter-spacing-densest': {
        value: -0.54,
        unit: 'px'
    },
    'font-letter-spacing-denser': {
        value: -0.3,
        unit: 'px'
    },
    'font-letter-spacing-dense': {
        value: -0.2,
        unit: 'px'
    },
    'font-letter-spacing-normal': {
        value: 0,
        unit: 'px'
    },
    'font-line-height-300': {
        value: size[300],
        unit: 'px'
    },
    'font-line-height-400': {
        value: size[400],
        unit: 'px'
    },
    'font-line-height-500': {
        value: size[500],
        unit: 'px'
    },
    'font-line-height-600': {
        value: size[600],
        unit: 'px'
    },
    'font-line-height-700': {
        value: size[700],
        unit: 'px'
    },
    'font-line-height-800': {
        value: size[800],
        unit: 'px'
    },
    'font-line-height-1000': {
        value: size[1000],
        unit: 'px'
    },
    'font-line-height-1200': {
        value: size[1200],
        unit: 'px'
    },
};